// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Icon from './common/icon'
import Beyond from './common/Beyond'
import Vconsole from 'vconsole';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import http from './http'
import util from './config/color'
import util2 from './config/levelInfo'
// new Vconsole();
Vue.use(ElementUI);

import './assets/css/reset.css'
Vue.component('b-icon', Icon);
Vue.component('b-beyond', Beyond);

Vue.prototype.$http = http;
Vue.prototype.$util = util;
Vue.prototype.$util2 = util2;
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js